import React, {useEffect, useState} from "react";
import {Col, Row} from "reactstrap";
import ReactCreditCards from "../../../../../custom/react-credit-cards";
import {formatMoney, getCardMonth} from "../../../../../../core/services/utils/utils";
import {CustomerPaymentMethodTypeNames} from "../../../../../../core/constants/enums";
import {OutlinedInputForm} from "../../../../base/input/outlined_input";
import Api from "../../../../../../core/services/api/api";
import useIsMounted from "../../../../../hooks/use-is-mounted";
import IconButton from "../../../../base/button/icon_button";
import {ArrowBack, CopyAll} from "@mui/icons-material";
import classnames from "classnames";
import Form from "../../../../base/form";
import * as Yup from "yup";
import ValidateMessages from "../../../../../../core/models/static/texts/vallidate-messages";
import {makeRequired, makeValidate} from "mui-rff";


const schema = Yup.object().shape({
    amount: Yup.number().nullable().required(ValidateMessages.required)
        .typeError(ValidateMessages.incorrectType('Amount'))
        .min(0.01, ValidateMessages.greaterThan('0')),
});

const validate = makeValidate(schema);
const required = makeRequired(schema);

const PayCustomerOrderOnlinePaymentSection = ({
                                                  selectedCard,
                                                  remainingBalance,
                                                  minChargeAmount,
                                                  showPreAuthMargin = false,
                                                  canGoBack,
                                                  goBack,
                                                  pay,
                                                  formId,
                                              }) => {
    const [seeBackOfCard, setSeeBackOfCard] = useState(false);
    const [preAuthMargin, setPreAuthMarginPercentage] = useState(0);
    const isMounted = useIsMounted();


    /**
     * With each change in the value of [showPreAuthMargin] prop:
     * - if set to true, then fetches the pre-auth payment margin from the server.
     */
    useEffect(() => {
        if (!showPreAuthMargin) {
            return setPreAuthMarginPercentage(0);
        }
        getPreAuthPaymentMarginPercentage().then();
    }, [showPreAuthMargin])

    /**
     * Fetches the pre-authorization payment's margin percentage amount that is to be applied to the amount of the
     * order payment.
     */
    const getPreAuthPaymentMarginPercentage = async () => {
        const response = await Api.getQuoteAuthPaymentMarginPercentage();
        if (!isMounted())
            return;
        if (response?.resultFlag) {
            setPreAuthMarginPercentage(response.data ?? 0);
        }
    }

    return (
        <>
            {
                canGoBack &&
                <Row className='mt-2 no-gutters w-100'>
                    <IconButton

                        onPressed={() => goBack()}
                        color={'secondary'}
                    >
                        <ArrowBack className={'icon normal'}/>
                    </IconButton>
                    <p className={classnames('text-md text-color-1 ml-2')}>
                        Would you like to Proceed with the payment ?
                    </p>
                </Row>
            }
            <div className={'d-flex mt-2 w-100 justify-content-center'}>
                {
                    selectedCard?.id === -1
                    && <div
                        onClick={() => setSeeBackOfCard(prevState => !prevState)}
                        className={'credit-card-confirmation-preview'}
                    >
                        <ReactCreditCards
                            cvc={selectedCard?.cVV}
                            expiry={`${selectedCard.month}/${selectedCard?.year}`}
                            focused={seeBackOfCard ? 'cvc' : 'number'}
                            name={selectedCard?.holderName}
                            number={selectedCard.cardNumber}
                        />
                    </div>
                }
                {
                    selectedCard?.id !== 1 &&
                    <div onClick={() => setSeeBackOfCard(prevState => !prevState)}
                         className={'credit-card-confirmation-preview'}
                    >
                        <ReactCreditCards
                            preview
                            cvc={'***'}
                            expiry={`${getCardMonth(selectedCard?.month)}/**`}
                            focused={seeBackOfCard ? 'cvc' : 'number'}
                            name={'******* *******'}
                            number={`************${selectedCard?.lastFourDigits}`}
                            issuer={CustomerPaymentMethodTypeNames[selectedCard?.type] ?? 'unknown'}

                        />
                    </div>
                }
            </div>
            <Form
                id={formId}
                className='w-100'
                onSubmit={pay}
                validate={validate}
                initialValues={{}}
                render={({values, form}) => {
                    const amountAfterPreAuthMargin = parseFloat(values?.amount ?? '0') * ((preAuthMargin ?? 0) / 100) + parseFloat(values?.amount ?? '0');
                    return <Row
                        className='no-gutters justify-content-center align-items-center w-100 mt-4'>
                        <Col xs={12}>
                            <div className='text-color-3 text-start text-sm mb-4 mx-5 d-inline-block'>
                                You can choose the amount of this payment. Your total remaining balance is
                                <span className={'ml-2 font-weight-semi-bold text-md black'}>
                                {formatMoney(remainingBalance)}
                            </span>
                                <span className={'ml-2'}>
                                   <IconButton
                                       color={'secondary'}
                                       onPressed={() => form.change('amount', remainingBalance?.toString())}
                                   >
                                       <CopyAll className={'icon small'}/>
                                   </IconButton>
                                </span>
                            </div>
                        </Col>
                        <Col xs={12} className={'px-4 mt-4'}>
                            <OutlinedInputForm
                                label={'Amount'}
                                name={'amount'}
                                type={'number'}
                                min={'0'}
                                required={required.amount}
                                value={values?.amount ?? ''}
                                onChange={(e) => form.change(
                                    e.target.name,
                                    !e.target.value
                                        ? undefined
                                        : parseFloat(e.target.value) >= minChargeAmount
                                            ? e.target.value
                                            : minChargeAmount
                                )}
                                {...(
                                    showPreAuthMargin && !!preAuthMargin && !!values?.amount && !validate(values)?.amount
                                        ? {
                                            helperText: (
                                                <>
                                                    The actual amount of <span
                                                    className={'payment-margin-note-amount'}>
                                                {formatMoney(amountAfterPreAuthMargin)}
                                            </span> Will be posted on your authorized transactions.
                                                </>
                                            )
                                        }
                                        : {}
                                )}
                            />
                        </Col>
                        <div className='w-100 my-2'/>
                    </Row>
                }}
            />
        </>
    )
}

export default PayCustomerOrderOnlinePaymentSection;
